module.exports = __webpack_public_path__ + "static/media/model-d-max-12.5423dd8c.jpg";